module.exports = __webpack_public_path__ + "static/PEDI-BELLO-logo-533db9379dfe8ec52f3f6cbac291ffdc.png";